import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse, LeadContact} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class LeadKeyPersonService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'LeadKeyPerson/';
  // fetch all LeadContact in the database
  allLeadKeyPerson(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getLeadKeyPerson(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  postLeadKeyPerson( data: any):Observable<CommonResponse>{
    return this.http.post<CommonResponse>(this.baseUrl, data);
  }
  deleteLeadKeyPerson(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateLeadKeyPerson(id: any, data: any):Observable<CommonResponse>{
    return this.http.put<CommonResponse>(this.baseUrl +id, data);
  }
}
